import React from 'react';
import Footer from '../../layout/footers/footer';
import Header from '../../layout/headers/header';
import EsqueciASenhaArea from './esqueci-a-senha';

const index = () => {
  return (
    <>
      {/* header start */}
      <Header header_shadow={true} />
      {/* header end */}

      {/* area start */}
      <EsqueciASenhaArea />
      {/* area end */}

      {/* footer area start */}
      <Footer pt="pt-90" />
      {/* footer area end */}
    </>
  );
};

export default index;